import * as React from 'react';
import { PeopleFinderStore, DisplayedPeopleType } from './stores/PeopleFinderStore';
import { Provider } from 'mobx-react';
import { PeopleFinder } from './PeopleFinder';
import { ITenantSettings } from '../../interfaces/ITenantSettings';
import { IConfig } from '../../interfaces/IConfig';
import { IPeopleFinderDesign } from '../../interfaces/IPeopleFinderDesign';

export interface IPeopleFinderProps {
  type: 'navigator' | 'webpart';
  tenant: string;
  token: string;
  config?: IConfig;
  onClose?: () => void;
  design: IPeopleFinderDesign;
  height?: number;
  width?: number;
  environment?: 'Development' | 'Test' | 'Production';
  isShowing?: boolean;
  tenantSettings?: ITenantSettings;
}

export class IAPeopleFinder extends React.Component<IPeopleFinderProps> {
  private peopleFinderStore = new PeopleFinderStore();

  public constructor(props: IPeopleFinderProps) {
    super(props);
    const headerHeight = 100;

    this.peopleFinderStore.type = props.type;
    this.peopleFinderStore.environment = props.environment;
    this.peopleFinderStore.settings = props.tenantSettings;
    this.peopleFinderStore.tenant = props.tenant;
    this.peopleFinderStore.tenantName = props.tenant.split('.')[0];
    this.peopleFinderStore.token = props.token;

    this.peopleFinderStore.height = props.height;
    this.peopleFinderStore.width = props.width;
    this.peopleFinderStore.contentHeight = props.height - headerHeight;
    this.peopleFinderStore.headerHeight = headerHeight;

    this.peopleFinderStore.design = props.design;
    this.peopleFinderStore.pagingIndex = 0;

    this.peopleFinderStore.displayedCardType = DisplayedPeopleType.SUGGESTED;
  }

  public render() {
    return (
      <Provider peopleFinderStore={this.peopleFinderStore}>
        <PeopleFinder onClose={() => this.props.onClose()} />
      </Provider>
    );
  }
}
